import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../core/components/ui/button";
import { Icon } from "../../../core/components/ui/icon";
import { AppointmentModal } from "./appointment-modal";
import { InstallButton } from "./install-button";

/**
 * Barre du haut de l'atelier : une recherche qui mène à la liste des travaux
 * (client, véhicule, plaque) et le bouton « Nouveau rendez-vous », partout,
 * à un tap. Sur téléphone, la recherche cède la place au seul bouton.
 */
export function AtelierTopbar() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [creating, setCreating] = useState(false);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/travaux?onglet=tous&q=${encodeURIComponent(q)}` : "/travaux");
    setQuery("");
  };

  return (
    <div className="atelier-topbar">
      {/* Le logo : sur tablette et téléphone, la barre latérale est repliée —
          c'est ici que la marque est « en haut à gauche ». */}
      <img
        className="atelier-topbar__logo"
        src="/brand/logo.svg"
        alt="PROTECTO"
        width={117}
        height={32}
      />
      <form className="atelier-topbar__search" role="search" onSubmit={submit}>
        <span className="atelier-topbar__search-icon" aria-hidden="true">
          <Icon name="search" size={18} />
        </span>
        <input
          type="search"
          className="atelier-topbar__input"
          aria-label="Rechercher un travail (client, véhicule, plaque)"
          placeholder="Client, véhicule, plaque…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoComplete="off"
          enterKeyHint="search"
        />
      </form>
      <InstallButton />
      <Button
        variant="primary"
        icon={<Icon name="plus" size={18} />}
        onClick={() => setCreating(true)}
        aria-label="Nouveau rendez-vous"
        title="Nouveau rendez-vous"
      >
        <span className="atelier-topbar__btn-label">Nouveau rendez-vous</span>
      </Button>
      <AppointmentModal
        open={creating}
        onClose={() => setCreating(false)}
        onSaved={(a) => {
          setCreating(false);
          navigate(`/travaux/${a.id}`);
        }}
      />
    </div>
  );
}
